import { createFileRoute, redirect } from '@tanstack/react-router';

import { getSupplierDetails } from '../common/api/clients/company.api';

export const Route = createFileRoute('/_app/supplier/detail/$id')({
    beforeLoad: async ({ params }) => {
        const supplier = await getSupplierDetails(params.id);
        const groupId = supplier.supplierGroupId;
        throw redirect({
            to: '/supplier-groups/$groupId/companies/$companyId',
            params: { groupId: groupId, companyId: params.id },
        });
    },
});
